module.exports = __webpack_public_path__ + "8ebcbf3aca8ea8fb05dc7787aef209f1.png";